/* global gtag */
angular.module('services.newman.ThemesService', [
  'global'
])

/**
 * The ThemesService handles loading theme files
 *
 * @class ThemesService
 * @constructor
 * @module services.newman.ThemesService
 */
.factory('ThemesService', [
  '$http',
  '$rootScope',
  function ($http, $rootScope) {
    'use strict';

    var service = {
      applyGACode: function (code) {
        if (!angular.element('#gacode').length) {
          angular.element('body').append('<script>window["gtag_disable_' + code + '"] = true;</script>');
          angular.element('body').append('<script id="gacode" async src="https://www.googletagmanager.com/gtag/js?id=' + code + '"></script>');
          // gtag('js', new Date());
          // gtag('config', code);
        }
      },
      /**
       * Loads a theme's json configuration file.
       *
       * @param {string} name - theme name to load
       * @return {Promise<Object>} Configuration object
       */
      getThemeConfig: function (name) {
        if (name === 'bls') {
          service.applyGACode('UA-45913200-11');
        } else if (name === 'healthProfessions') {
          service.applyGACode('UA-45913200-12');
        } else if (name === 'nursing') {
          service.applyGACode('UA-45913200-13');
        }
        return $http.get($rootScope.rootpath + '/themes/' + name + '/config.json');
      }
    };

    return service;
  }
]);
